'use client';

import '~/shared/styles/autofill.scss';

import { Layout } from 'antd';
import classNames from 'classnames';

import AdditionalMenu from '~/shared/components/header/components/additional-menu';
import MainMenu from '~/shared/components/header/components/main-menu';
import MobileMenu from '~/shared/components/header/components/mobile-menu/mobile-menu';
import useHeader from '~/shared/components/header/use-header';
import type { UserMenuItem } from '~/shared/configs/menus/get-user-menu-items-config';
import type { Locale } from '~/shared/constants';
import { getClientUser, getReferralClientUser } from '~/shared/helpers/client-user-helpers';

import './header.scss';

type HeaderProps = Readonly<{
  lng: Locale;
  isClientsPanel?: boolean;
  isPlatform?: boolean;
  isAdminPanel?: boolean;
  hidePlatformNavigation?: boolean;
  menuItems?: UserMenuItem[];
  onSignOutCallback?: () => void;
}>;

const { Header: AntDHeader } = Layout;

const Header = ({
  lng,
  isClientsPanel = false,
  onSignOutCallback,
  isPlatform = false,
  isAdminPanel = false,
  hidePlatformNavigation = false,
  menuItems = [],
}: HeaderProps) => {
  const { onMobileMenuClose, isMainMenuToggled, setIsMainMenuToggled } = useHeader();
  const user = isClientsPanel ? getReferralClientUser() : getClientUser();

  return (
    <>
      <AntDHeader itemScope itemType="https://schema.org/WPHeader" className={classNames('header__wrapper')}>
        <div className={classNames('header', 'header__container')}>
          <MainMenu
            isClientsPanel={isClientsPanel}
            isAdminPanel={isAdminPanel}
            isPlatform={isPlatform}
            hideNavigation={hidePlatformNavigation}
            user={user}
            lng={lng}
          />
          <AdditionalMenu
            onSignOutCallback={onSignOutCallback}
            lng={lng}
            user={user}
            setIsMainMenuToggled={setIsMainMenuToggled}
            isPlatformNavigationHidden={hidePlatformNavigation}
          />
        </div>
      </AntDHeader>

      <div id="header" className="header__background" />

      <MobileMenu
        lng={lng}
        user={user}
        isPlatform={isPlatform}
        isAdminPanel={isAdminPanel}
        onMobileMenuClose={onMobileMenuClose}
        isMainMenuToggled={isMainMenuToggled}
        menuItems={menuItems}
      />
    </>
  );
};

export default Header;
